import React, { lazy, Suspense } from "react";
import Loader from "../components/Loader";

function withLazy(importFunc) {
  const LazyComponent = lazy(importFunc);
  return function WrappedComponent(props) {
    return (
      <Suspense fallback={<Loader />}>
        <LazyComponent {...props} />
      </Suspense>
    );
  };
}

export default withLazy;
